// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__114FH","rootNoMargin":"styles_rootNoMargin__qGRk_"};